import { Component, computed, input, ViewEncapsulation, ChangeDetectionStrategy } from "@angular/core";
import { CalendarData } from "../../modules/home/calendar/CalendarData";
import { ModalService } from "../../modules/modal/modal.service";
import { S25ItemComponent } from "../../modules/s25-item/s25.item.component";
import { Item } from "../../pojo/Item";
import { Task } from "../../pojo/Task";
import { S25Util } from "../../util/s25-util";

@Component({
    selector: "s25-ng-calendar-subject",
    standalone: true,
    imports: [S25ItemComponent],
    template: `
        @if (subject().is_hidden) {
            <div class="ngHiddenSubject">{{ subject().itemName }}</div>
        } @else if (+subject().itemTypeId === Item.Ids.Task) {
            <s25-item
                class="item s25-object ngSubjectItem"
                [itemId]="subject().taskId ?? subject().itemId"
                [itemTypeId]="itemTypeId()"
                [itemName]="subject().itemName"
                [hidePopover]="true"
                [typeIconClass]="Task.State.iconClass(this.subject().itemStateId)"
                [includeTypeIcon]="true"
                [hideLabel]="true"
                [detailsOverrideFn]="createEditTaskModal"
                [blockContextMenu]="true"
            ></s25-item>
        } @else {
            <s25-item
                class="item ngSubjectItem"
                [itemId]="subject().itemId"
                [itemTypeId]="subject().itemTypeId"
                [itemName]="subject().itemName"
                [hideLabel]="true"
                [includeTypeIcon]="true"
            />
        }
        @if (subject().has_more && isLast()) {
            <div class="ngInlineBlock ngWidth100 ngMultLocMsg {{ Reservation.classes(reservation()) }}">
                <i class="ngMultipleSubject">(more {{ PluralName[itemTypeId()] }})</i>
            </div>
        }
        @if (subject().comment) {
            <div class="ng25LiveGrey">{{ subject()?.comment }}</div>
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: `
        .item ::ng-deep .s25-item-holder {
            display: inline-flex;
            align-items: center;
            padding: 3px 1px;
        }
    `,
})
export class CalendarSubject {
    readonly subject = input.required<CalendarData.Subject>();
    readonly reservation = input.required<CalendarData.Reservation>();
    readonly isLast = input<boolean>(false);

    readonly itemTypeId = computed<Item.Id>(() => S25Util.parseInt(this.subject().itemTypeId));

    protected readonly Item = Item;
    protected readonly Task = Task;
    protected readonly Reservation = CalendarData.Reservation;
    protected readonly PluralName: { [typeId in Item.Id]?: string } = {
        [Item.Ids.Organization]: "organizations",
        [Item.Ids.Location]: "locations",
        [Item.Ids.Resource]: "resources",
        [Item.Ids.Task]: "tasks",
    };
    protected readonly createEditTaskModal = () => {
        if (!this.subject().taskType || !this.subject().taskId) {
            console.warn(
                `Unexpected missing values for {taskType: ${this.subject().taskType}, taskId: ${this.subject().taskId}}`,
            );
        }
        return ModalService.modal("create-edit-task", {
            type: "edit",
            taskType: this.subject().taskType!,
            taskId: this.subject().taskId ?? this.subject().itemId,
            eventId: this.reservation().event_id,
            taskActionsCell: {
                itemTypeId: this.subject().taskType!,
                itemStateId: this.subject().itemStateId!,
            },
        });
    };
}
